export const DEFAULT_LOCALE = "cs";

export const vocFrequency = [
  {
    id: "ANNUAL_2",
    key: "biannual"
  },
  {
    id: "ANNUAL_3",
    key: "threeTimesAYear"
  },
  {
    id: "BIENNIAL",
    key: "twoYearOld"
  },
  {
    id: "BIMONTHLY",
    key: "bimonthly"
  },
  {
    id: "BIWEEKLY",
    key: "biweekly"
  },
  {
    id: "DAILY_2",
    key: "twiceADay"
  },
  {
    id: "DECENNIAL",
    key: "decennial"
  },
  {
    id: "IRREG",
    key: "irregular"
  },
  {
    id: "MONTHLY_2",
    key: "twiceAMonth"
  },
  {
    id: "MONTHLY_3",
    key: "threeTimesAMonth"
  },
  {
    id: "QUADRENNIAL",
    key: "quadrennial"
  },
  {
    id: "QUARTERLY",
    key: "quarterly"
  },
  {
    id: "QUINQUENNIAL",
    key: "quinquennial"
  },
  {
    id: "TRIENNIAL",
    key: "threeYearOld"
  },
  {
    id: "UPDATE_CONT",
    key: "continuouslyUpdated"
  },
  {
    id: "WEEKLY_2",
    key: "twoTimesAWeek"
  },
  {
    id: "WEEKLY_3",
    key: "threeTimesAWeek"
  }
];

export const vocThemes = [
  {
    id: "AGRI",
    key: "agricultureFisheriesForestryAndNutrition"
  },
  {
    id: "ECON",
    key: "economyAndFinance"
  },
  {
    id: "EDUC",
    key: "educationCultureAndSport"
  },
  {
    id: "ENER",
    key: "energy"
  },
  {
    id: "ENVI",
    key: "environment"
  },
  {
    id: "GOVE",
    key: "governmentAndPublicSector"
  },
  {
    id: "HEAL",
    key: "health"
  },
  {
    id: "INTR",
    key: "internationalIssues"
  },
  {
    id: "JUST",
    key: "justiceLegalSystemAndPublicSecurity"
  },
  {
    id: "REGI",
    key: "regionsAndCities"
  },
  {
    id: "SOCI",
    key: "populationAndSociety"
  },
  {
    id: "TECH",
    key: "scienceAndTechnology"
  },
  {
    id: "TRAN",
    key: "transport"
  }
];

export const vocCategories = [
  {
    id: "04",
    key: "politicalLife"
  },
  {
    id: "0406",
    key: "politicalFramework"
  },
  {
    id: "0411",
    key: "politicalParty"
  },
  {
    id: "0416",
    key: "electoralProcessAndVoting"
  },
  {
    id: "0421",
    key: "parliament"
  },
  {
    id: "0426",
    key: "parliamentaryWork"
  },
  {
    id: "0431",
    key: "politicalLifeAndPublicSecurity"
  },
  {
    id: "0436",
    key: "executiveAndStateAdministration"
  },
  {
    id: "08",
    key: "internationalRelationships"
  },
  {
    id: "0806",
    key: "internationalPolitics"
  },
  {
    id: "0811",
    key: "cooperationPolicy"
  },
  {
    id: "0816",
    key: "internationalSecurity"
  },
  {
    id: "0821",
    key: "defense"
  },
  {
    id: "10",
    key: "europeanUnion"
  },
  {
    id: "1006",
    key: "euInstitutionsAndEuropeanPublicService"
  },
  {
    id: "1011",
    key: "europeanUnionLegislation"
  },
  {
    id: "1016",
    key: "communityStructure"
  },
  {
    id: "1021",
    key: "financeEu"
  },
  {
    id: "12",
    key: "law"
  },
  {
    id: "1206",
    key: "sourcesAndBranchesOfLaw"
  },
  {
    id: "1211",
    key: "civilLaw"
  },
  {
    id: "1216",
    key: "criminalLaw"
  },
  {
    id: "1221",
    key: "judiciary"
  },
  {
    id: "1226",
    key: "legalSystemOrganization"
  },
  {
    id: "1231",
    key: "internationalLaw"
  },
  {
    id: "1236",
    key: "rightsAndFreedoms"
  },

  {
    id: "16",
    key: "economy"
  },
  {
    id: "1606",
    key: "economicPolicy"
  },
  {
    id: "1611",
    key: "economicSituation"
  },
  {
    id: "1616",
    key: "regionsAndRegionalPolicy"
  },
  {
    id: "1621",
    key: "economicStructure"
  },
  {
    id: "1626",
    key: "nationalAccounts"
  },
  {
    id: "1631",
    key: "economicAnalysis"
  },
  {
    id: "20",
    key: "trade"
  },
  {
    id: "2006",
    key: "tradePolicy"
  },
  {
    id: "2011",
    key: "customsPolicy"
  },
  {
    id: "2016",
    key: "store"
  },
  {
    id: "2021",
    key: "internationalTrade"
  },
  {
    id: "2026",
    key: "consumption"
  },
  {
    id: "2031",
    key: "marketing"
  },
  {
    id: "2036",
    key: "distribution"
  },
  {
    id: "24",
    key: "financial"
  },
  {
    id: "2406",
    key: "monetaryRelations"
  },
  {
    id: "2411",
    key: "monetaryEconomy"
  },
  {
    id: "2416",
    key: "creditAndFinancialInstitutions"
  },
  {
    id: "2421",
    key: "freeMovementOfCapital"
  },
  {
    id: "2426",
    key: "financingAndInvestment"
  },
  {
    id: "2431",
    key: "insurance"
  },
  {
    id: "2436",
    key: "publicFinancesAndBudgetaryPolicy"
  },
  {
    id: "2441",
    key: "budget"
  },
  {
    id: "2446",
    key: "taxSystem"
  },
  {
    id: "2451",
    key: "prices"
  },

  {
    id: "28",
    key: "socialIssues"
  },
  {
    id: "2806",
    key: "family"
  },
  {
    id: "2811",
    key: "migration"
  },
  {
    id: "2816",
    key: "demographyAndPopulation"
  },
  {
    id: "2821",
    key: "socialFramework"
  },
  {
    id: "2826",
    key: "socialRelations"
  },
  {
    id: "2831",
    key: "cultureAndReligion"
  },
  {
    id: "2836",
    key: "socialProtection"
  },
  {
    id: "2841",
    key: "health"
  },
  {
    id: "2846",
    key: "urbanismAndConstruction"
  },

  {
    id: "32",
    key: "educationAndCommunication"
  },
  {
    id: "3206",
    key: "educationAndTraining"
  },
  {
    id: "3211",
    key: "education"
  },
  {
    id: "3216",
    key: "educationOrganization"
  },
  {
    id: "3221",
    key: "documentation"
  },
  {
    id: "3226",
    key: "communication"
  },
  {
    id: "3231",
    key: "informationAndInformationProcessing"
  },
  {
    id: "3236",
    key: "informatics"
  },
  {
    id: "36",
    key: "science"
  },
  {
    id: "3606",
    key: "naturalAndAppliedSciences"
  },
  {
    id: "3611",
    key: "humanities"
  },
  {
    id: "40",
    key: "businessAndCompetition"
  },
  {
    id: "4006",
    key: "enterpriseOrganization"
  },
  {
    id: "4011",
    key: "kindsOfBusinesses"
  },
  {
    id: "4016",
    key: "legalFormOfOrganizations"
  },
  {
    id: "4021",
    key: "management"
  },
  {
    id: "4026",
    key: "bookkeeping"
  },
  {
    id: "4031",
    key: "competition"
  },
  {
    id: "44",
    key: "employmentAndWork"
  },
  {
    id: "4406",
    key: "employment"
  },
  {
    id: "4411",
    key: "laborMarket"
  },
  {
    id: "4416",
    key: "workOrganizationAndWorkingConditions"
  },
  {
    id: "4421",
    key: "workAndWages"
  },
  {
    id: "4426",
    key: "laborRelations"
  },

  {
    id: "48",
    key: "transport"
  },
  {
    id: "4806",
    key: "transportPolicy"
  },
  {
    id: "4811",
    key: "transportOrganization"
  },
  {
    id: "4816",
    key: "landTransport"
  },
  {
    id: "4821",
    key: "waterTransport"
  },
  {
    id: "4826",
    key: "airAndSpaceTransport"
  },
  {
    id: "52",
    key: "environment"
  },
  {
    id: "5206",
    key: "environmentalPolicy"
  },
  {
    id: "5211",
    key: "naturalEnvironment"
  },
  {
    id: "5216",
    key: "environmentalDamage"
  },
  {
    id: "56",
    key: "agricultureForestryAndFishing"
  },
  {
    id: "5606",
    key: "agriculturalPolicy"
  },
  {
    id: "5611",
    key: "agriculturalStructuresAndAgriculturalProduction"
  },
  {
    id: "5616",
    key: "farmingSystems"
  },
  {
    id: "5621",
    key: "tillage"
  },
  {
    id: "5626",
    key: "agriculturalMeansOfProduction"
  },
  {
    id: "5631",
    key: "agriculturalActivity"
  },
  {
    id: "5636",
    key: "forestry"
  },
  {
    id: "5641",
    key: "fishing"
  },
  {
    id: "60",
    key: "agricultureAndNutrition"
  },
  {
    id: "6006",
    key: "plantProduct"
  },
  {
    id: "6011",
    key: "animalProduct"
  },
  {
    id: "6016",
    key: "processedAgriculturalProducts"
  },
  {
    id: "6021",
    key: "drinksAndSugar"
  },
  {
    id: "6026",
    key: "foodstuffs"
  },
  {
    id: "6031",
    key: "agriFoodSector"
  },
  {
    id: "6036",
    key: "foodTechnology"
  },
  {
    id: "64",
    key: "productionTechnologyAndResearch"
  },
  {
    id: "6406",
    key: "production"
  },
  {
    id: "6411",
    key: "technologyAndTechnicalRegulations"
  },
  {
    id: "6416",
    key: "researchAndIntellectualProperty"
  },
  {
    id: "66",
    key: "energy"
  },
  {
    id: "6606",
    key: "energyPolicy"
  },
  {
    id: "6611",
    key: "coalAndMining"
  },
  {
    id: "6616",
    key: "petroleumIndustry"
  },
  {
    id: "6621",
    key: "electricityAndNuclearIndustry"
  },
  {
    id: "6626",
    key: "alternativeEnergy"
  },
  {
    id: "68",
    key: "industry"
  },
  {
    id: "6806",
    key: "industrialPolicyAndStructure"
  },
  {
    id: "6811",
    key: "chemistry"
  },
  {
    id: "6816",
    key: "metallurgyOfFerrousAndNonFerrousMetals"
  },
  {
    id: "6821",
    key: "engineering"
  },
  {
    id: "6826",
    key: "electronicsAndElectrical"
  },
  {
    id: "6831",
    key: "buildingAndCivilEngineering"
  },
  {
    id: "6836",
    key: "woodIndustry"
  },
  {
    id: "6841",
    key: "textileAndLeather"
  },
  {
    id: "6846",
    key: "differentIndustries"
  },
  {
    id: "72",
    key: "geography"
  },
  {
    id: "7206",
    key: "europe"
  },
  {
    id: "7211",
    key: "euMemberStateRegions"
  },
  {
    id: "7216",
    key: "america"
  },
  {
    id: "7221",
    key: "africa"
  },
  {
    id: "7226",
    key: "asiaAndOceania"
  },
  {
    id: "7231",
    key: "economicGeography"
  },
  {
    id: "7236",
    key: "politicalGeography"
  },
  {
    id: "7241",
    key: "overseasCountriesAndTerritories"
  },
  {
    id: "76",
    key: "internationalOrganisation"
  },
  {
    id: "7606",
    key: "unitedNations"
  },
  {
    id: "7611",
    key: "europeanOrganization"
  },
  {
    id: "7616",
    key: "nonEuropeanOrganizations"
  },
  {
    id: "7621",
    key: "worldOrganizations"
  },
  {
    id: "7626",
    key: "aNonGovernmentalOrganization"
  }
];
